// 계정 신청을 받을 수 없는 메일 주소.
//
// 신청의 모든 것이 인증 메일 한 통에 달려 있다 — 그 링크를 열지 못하면 아이디도
// 비밀번호도 생기지 않는다. 그래서 메일이 닿지 않는 곳은 신청을 받아 두는 것이
// 받지 않는 것보다 나쁘다: 기다리게 하고, 왜 안 되는지도 말해 주지 못한다.
//
// 여기 적힌 도메인은 메일이 실제로 도착하지 않은 곳이다. 메일 경로가 고쳐지면
// (#348) 이 목록은 비워야 하는 목록이고, 그때까지의 임시 가드다. 화면만 막으므로
// 서버는 여전히 받는다 — 이것은 사람이 헛되이 기다리지 않게 하는 안내이지 관문이 아니다.
const BLOCKED_EMAIL_DOMAINS: readonly string[] = ['dau.ac.kr']

/** 이 주소로는 인증 메일이 도착하지 않는가. 도메인만 본다. */
export function mailUnreachable(email: string): boolean {
  const at = email.trim().toLowerCase().lastIndexOf('@')
  if (at < 0) return false
  const domain = email.trim().toLowerCase().slice(at + 1)
  return BLOCKED_EMAIL_DOMAINS.some((d) => domain === d || domain.endsWith('.' + d))
}

/** 막힌 이유와 조치. 왜 도착하지 않는지는 쓰는 사람이 할 수 있는 일이 아니다. */
export const MAIL_UNREACHABLE_WORD = '이 주소로는 인증 메일이 도착하지 않습니다. 다른 메일 주소로 신청하세요.'

/** 가입의 이메일 도메인 선택지. `EMAIL_DOMAIN_CUSTOM` 이 `직접 입력` 이다 — 그때는 주소 전체를 적는다. */
export const EMAIL_DOMAINS: readonly string[] = ['gmail.com', 'naver.com', 'daum.net', 'hanmail.net', 'kakao.com', 'nate.com', 'outlook.com']
export const EMAIL_DOMAIN_CUSTOM = ''

// 아이디는 VM 안의 리눅스 계정 이름이 된다 — 백엔드와 같은 규칙(`api/models.yaml` 의 `SignupRequest.username`).
// 규칙을 화면이 말하지 않으면 사람은 같은 거절을 되풀이해 받는다. 그래서 쓸 수 없는 글자는 칸에
// 들어가지도 않고, 걸러 낸 뒤에 남는 유일한 어김(첫 글자가 숫자나 하이픈)은 그 자리에서 문장이 된다.
const LOGIN_NAME_RE = /^[a-z_][a-z0-9_-]{0,31}$/
export const LOGIN_NAME_HINT = '소문자로 시작, 소문자·숫자·밑줄·하이픈, 32자까지'
export const LOGIN_NAME_RULE = '아이디는 영문 소문자로 시작하고 영문 소문자·숫자·밑줄(_)·하이픈(-)만 씁니다.'

export function loginNameOk(v: string): boolean {
  return LOGIN_NAME_RE.test(v)
}

/**
 * 아이디 칸의 걸러개. 대문자는 소문자로 바꾸고 쓸 수 없는 글자는 버린다 —
 * 한글과 공백·`@`·`.` 은 칸에 나타나지도 않는다.
 *
 * 대문자를 버리지 않고 바꾸는 이유가 있다: 전화 자판은 첫 글자를 저절로 대문자로 만들어
 * 버리면 친 글자가 사라진 것처럼 보인다.
 */
export function loginNameTyped(raw: string): string {
  return raw.toLowerCase().replace(/[^a-z0-9_-]/g, '')
}

/** 앞부분과 고른 도메인을 보낼 주소 하나로 합친다. 직접 입력이면 적은 주소 그대로다. 앞부분이 비면 빈 주소다. */
export function joinEmail(local: string, domain: string, typed: string): string {
  if (domain === EMAIL_DOMAIN_CUSTOM) return typed.trim()
  const l = local.trim()
  return l ? `${l}@${domain}` : ''
}
